import { useAppQuery } from './useAppQuery';

interface TrainingStudentFilterItem {
  id: string;
  name: string;
}

interface TrainingStudentFiltersResponse {
  faculties: TrainingStudentFilterItem[];
  courses: TrainingStudentFilterItem[];
}

export const useGetTrainingStudentFilters = (providerId?: string) => {
  return useAppQuery<TrainingStudentFiltersResponse>('/TrainingManager/students/filters', {
    config: {
      params: { providerId: providerId || undefined },
    },
  });
};
